import {getAction, postAction, putAction} from "../service/http/api";

export default {
  methods:{
    /**
     * 加载数据
     */
    loadData(){
      getAction(this.url.query,{id:this.rowId}).then(res=>{
        this.formData = res.data;
        if(this.init){
          this.init();
        }
      })
    },
    /**
     * 点击取消按钮
     */
    onClose() {
      this.$refs.myPopbox.isVisible = false;
      this.$emit('close');
    },
    /**
     * 保存按钮
     */
    onOk(){
      if(!this.$refs.myPopbox) return;
      this.$refs.myPopbox.isVisible = false;
      this.$emit('ok');
    },
    /**
     * 点击保存按钮
     */
    onSave(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.mode==='new'){
            postAction(this.url.add,this.formData).then(res=>{
              if(res.code===200){
                this.$message({
                  message:'保存成功',
                  type:"success"
                });
                if(this.afterSave){
                  this.afterSave(res.data);
                }
                this.onOk();
              }
            })
          }else if(this.mode ==='edit'){
            putAction(this.url.edit,this.formData).then(res=>{
              if(res.code===200){
                this.$message({
                  message:'保存成功',
                  type:"success"
                });
                if(this.afterSave){
                  this.afterSave(this.formData.id);
                }
                this.onOk();
              }
            })
          }
        }
      });
    }
  },
  created(){
    if(this.mode==='edit'){
      this.loadData();
    }
  },
  mounted(){
    this.$refs.myPopbox.isVisible = true;
  }
}



// WEBPACK FOOTER //
// ./src/mixin/editModal.js